// removed by extract-text-webpack-plugin
module.exports = {"numberBadge":"NumberBadge__numberBadge","label":"NumberBadge__label"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/NumberBadge/NumberBadge.scss
// module id = 1795
// module chunks = 8